import { z } from 'zod';
/**
 * Three-phase migrations and the upgrade preflight (v0.11 design, sections 1
 * and 6): what System health shows under Upgrades and Background work.
 */
export const BACKGROUND_MIGRATION_BATCH_SIZE = { min: 1, max: 100_000 };
export const BACKGROUND_MIGRATION_PAUSE_MS = { min: 0, max: 600_000 };
/** Administrators change how fast a migration runs; auditors only read. */
export const updateBackgroundMigrationSchema = z
    .object({
    batchSize: z
        .number()
        .int()
        .min(BACKGROUND_MIGRATION_BATCH_SIZE.min)
        .max(BACKGROUND_MIGRATION_BATCH_SIZE.max)
        .optional(),
    pauseMs: z
        .number()
        .int()
        .min(BACKGROUND_MIGRATION_PAUSE_MS.min)
        .max(BACKGROUND_MIGRATION_PAUSE_MS.max)
        .optional(),
})
    .strict()
    .refine((value) => value.batchSize !== undefined || value.pauseMs !== undefined, {
    message: 'Change the batch size, the pause, or both',
});
//# sourceMappingURL=migrations.js.map